import EditForm from './_form'
import template from './edit.pug'

export default Vue.extend({
  template: template(),
  components: {
    EditForm
  },
  data() {
    return {
      ready: false,
      data: {},
      errors: {}
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.$setPageTitle(this.$t('staticPhone.edit.title'))
        this.loadData()
      }
    }
  },

  methods: {
    loadData() {
      this.ready = false
      API.callTrackingStaticNumbers.show(this.$route.params.id).then(response => {
        this.data = response
        this.ready = true

        this.$setBreadcrumbs([
          {label: this.$t('breadcrumbs.staticPhone.index'), route: {name: 'static-phone-index'}},
          {label: this.$t('breadcrumbs.staticPhone.edit', {name: this.data.name}), route: {}}
        ])
      })
    },

    updateCallTrackingStaticNumber(data) {
      API.callTrackingStaticNumbers.update(this.$route.params.id, data).then(() => {
        this.$notifications.success(this.$t('staticPhone.edit.succesfullyUpdated'))
        this.$router.push({name: 'static-phone-index'})
      }, errors => {
        this.errors = errors
      })
    }
  }
})
